import { doc, getDoc } from "firebase/firestore";
import store from "./store";
import { thisUserActions } from "./store/thisUser.js";
import { thisTutorActions } from "./store/thisTutor.js";
import { db } from "../utils/firebase.js";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const auth = getAuth();

const setThisUser = (user) => {
  store.dispatch(thisUserActions.set(user));
};

const setThisTutor = (user) => {
  store.dispatch(thisTutorActions.set(user));
};

const fetchThisUserData = async () => {
  onAuthStateChanged(auth, async (user) => {
    if (user) {
      const docRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setThisUser({ ...docSnap.data(), id: docSnap.id });
      } else {
        setThisUser(null);
        console.log("No such document!");
      }
    }
  });
};

const fetchThisTutorData = async () => {
  onAuthStateChanged(auth, async (user) => {
    if (user) {
      const docRef = doc(db, "tutors", user.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setThisTutor({ ...docSnap.data(), id: docSnap.id });
      } else {
        setThisTutor(null);
        console.log("No such document!");
      }
    }
  });
};

export { fetchThisUserData, fetchThisTutorData };
